import { SoundOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { createStyles } from 'antd-style'

import { queryNoticePageApi } from '@eastcoal/api/content/noticeMall/queryNoticePage'

import { AutoScroll } from '@eastcoal/common/components/AutoScroll'
import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { formatDate } from '@eastcoal/common/utils/date'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { RouterLink } from '@eastcoal/router/components/Link'

import { LayoutContainer } from '../../../../layouts/components/Container'
import {
  NOTICE_DETAIL_PAGE_PATH,
  NOTICE_LIST_PAGE_PATH
} from '../../../Content/Notice/constants/path'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    columnGap: token.padding
  },
  icon: {
    marginBlockStart: 2,
    marginInlineEnd: token.marginXS,
    color: token.volcano
  },
  label: {
    color: token.volcano
  },
  scroller: {
    height: 32,
    paddingInline: token.padding
  },
  item: {
    display: 'inline-flex',
    columnGap: token.paddingXS,
    paddingInline: token.paddingXL,
    flex: 'none',
    height: 32,
    lineHeight: '32px'
  },
  title: {
    color: token.colorText
  },
  date: {
    color: token.colorTextTertiary
  }
}))

const titleRender = (title?: string) =>
  (title?.length ?? 0) >= 23 ? title?.slice(0, 23) + '...' : title

export const NoticeBar = () => {
  const { data } = useRequest(queryNoticePageApi, {
    manual: false,
    retryCount: 5,
    retryInterval: 1000,
    defaultParams: [
      {
        current: '1',
        pageSize: '10',
        status: 1,
        orders: [{ column: 'publish_time', asc: false }]
      },
      { silence: true }
    ]
  })

  const { styles } = useStyles()

  return (
    <LayoutContainer className={styles.container}>
      <div>
        <SoundOutlined className={styles.icon} />
        <span className={styles.label}>网站公告</span>
      </div>
      <AutoScroll
        classNames={{ rootWrapper: styles.scroller }}
        orientation='horizontal'
      >
        {data?.records?.map(({ id, title, publishTime }) => (
          <RouterLink
            key={id}
            newtab
            to={stringifyUrl({
              url: NOTICE_DETAIL_PAGE_PATH,
              query: { id }
            })}
          >
            <div key={id} className={styles.item}>
              <span className={styles.title}>{titleRender(title)}</span>
              {publishTime && (
                <span className={styles.date}>
                  [{formatDate(publishTime, 'MM-DD')}]
                </span>
              )}
            </div>
          </RouterLink>
        ))}
      </AutoScroll>
      <NavigateButton newtab to={NOTICE_LIST_PAGE_PATH} type='link'>
        更多&gt;
      </NavigateButton>
    </LayoutContainer>
  )
}
